import { render } from "./calendarOld.vue?vue&type=template&id=e8a37e62&scoped=true&ts=true"
import script from "./calendarOld.vue?vue&type=script&lang=ts"
export * from "./calendarOld.vue?vue&type=script&lang=ts"

import "./calendarOld.vue?vue&type=style&index=0&id=e8a37e62&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a37e62"]])

export default __exports__